import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import TodayCashCollectionLayer from "../../../components/Admin/TodayCashCollectionLayer";

const TodayCashCollection = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <TodayCashCollectionLayer />
      </MasterLayout>
    </>
  );
};

export default TodayCashCollection